export default [
  {
    path: '/main/arena/linkvehicleandareagenerateevents',
    meta: {
      tag: 'list_arena_link_vehicle_and_area_generate_events',
      name: 'Vincular Veículo e Área - Gerar Eventos',
      breadcrumb: 'Vincular Veículo e Área - Gerar Eventos',
    },
    component: () => import(/* webpackChunkName: "linkvehicleandareagenerateevents" */ '@/views/main/settings/arena/link-vehicle-and-area-generate-events/Index.vue'),
    children: [
      {
        path: '',
        name: 'listarenalinkvehicleandareagenerateevents',
        meta: {
          tag: 'list_arena_link_vehicle_and_area_generate_events',
          menu: 'settings',
          name: 'Vincular Veículo e Área - Gerar Eventos',
        },
        component: () => import(/* webpackChunkName: "linkvehicleandareagenerateevents" */ '@/views/main/settings/arena/link-vehicle-and-area-generate-events/List.vue'),
      },
      {
        path: '/main/arena/linkvehicleandareagenerateevents/add',
        name: 'addarenalinkvehicleandareagenerateevents',
        meta: {
          tag: 'add_arena_link_vehicle_and_area_generate_events',
          menu: 'settings',
          name: 'Adicionar | Vincular Veículo e Área - Gerar Eventos',
          breadcrumb: 'Adicionar Vincular Veículo e Área - Gerar Eventos',
        },
        component: () => import(/* webpackChunkName: "linkvehicleandareagenerateeventsadd" */ '@/views/main/settings/arena/link-vehicle-and-area-generate-events/Add.vue')
      },
      {
        path: '/main/arena/linkvehicleandareagenerateevents/:id',
        name: 'editarenalinkvehicleandareagenerateevents',
        meta: {
          tag: 'edit_arena_link_vehicle_and_area_generate_events',
          menu: 'settings',
          name: 'Editar | Vincular Veículo e Área - Gerar Eventos',
          breadcrumb: 'Editar Vincular Veículo e Área - Gerar Eventos',
        },
        component: () => import(/* webpackChunkName: "linkvehicleandareagenerateeventsedit" */ '@/views/main/settings/arena/link-vehicle-and-area-generate-events/Edit.vue')
      }
    ]
  }
]
